/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectSponsors} from '../api'

export const useMutationSelectSponsors = createReactQueryMutationHook('selectSponsors', selectSponsors)
